module.exports = __webpack_public_path__ + "img/1.a3f2d836.png";